import { ref, Ref, computed } from '@vue/composition-api';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import store from '@/renderer/store/index';
import Crumbs from '../scripts/Crumbs';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const handler = () => {
  // 全量的团队树（初始时后代节点缺失部分属性，随着其父节点的被访问属性将逐渐完善）
  const teamTree: Ref<SMH.TeamTreeNode> = ref({} as SMH.TeamTreeNode);
  const methods = {
    /**
     * 从远程获取团队树/节点的值，
     * 返回值会被赋值给 teamNode 或整个团队树（无 teamNode 时）。
     */
    pullTeamNode: async (teamNode?: SMH.TeamTreeNode) => {
      const parmas: SMH.QueryTeamParams = {
        teamId: teamNode?.id || '',
        checkPermission: 1,
      };
      try {
        const ans = await smh.userAPI.queryTeam(parmas);
        const { data } = ans;
        if (teamNode) {
          Object.assign(teamNode, data);
        } else {
          teamTree.value = data;
        }
      } catch (error) {
        tips.error(error as MsgError);
      }
    },
  };

  // 所选空间类型（个人空间｜企业空间｜协作空间）
  const spaceType: Ref<'personal' | 'team' | 'group'> = ref(
    store.getters.editionFlag === 'personal' ? 'personal' : 'team',
  );
  const isHasPersonalSpace = computed(() => {
    spaceType.value = store.getters.hasPersonalSpace ? 'personal' : 'team';
    return store.getters.hasPersonalSpace;
  });
  const isPersonalSpaceType = computed(() => spaceType.value === 'personal');
  const isCoSpaceType = computed(() => spaceType.value === 'group');

  /**
   * 用户所选团队组成的团队路径
   */
  const teamNodeCrumbs = new Crumbs<SMH.TeamTreeNode>('id', value => {
    // 若当前节点或其子节点缺失 name 字段时，则认为需要拓展请求当前节点的更多信息
    if (!value.name || (value.children?.length && !value.children[0].name)) {
      !isPersonalSpaceType.value && methods.pullTeamNode(value);
    }
    return value;
  });

  /**
   * 当前所在团队空间
   */
  const currentTeamNode = computed(() => {
    if (!teamNodeCrumbs.value.length) {
      teamNodeCrumbs.push(teamTree.value);
    }
    return teamNodeCrumbs.value[teamNodeCrumbs.value.length - 1];
  });
  return {
    teamTree,
    isHasPersonalSpace,
    currentTeamNode,
    spaceType,
    isPersonalSpaceType,
    isCoSpaceType,
    teamNodeCrumbs,
    methods,
  };
};
export default handler;
